<template>
  <div>
    <!-- title="填写购买信息" -->
    <el-dialog center
               :title="payStatus?'支付结果':'确认订单'"
               :visible.sync="dialogVisible"
               width="30%"
               :close-on-click-modal="false"
               :before-close="handleClose">
      <div v-show="!payStatus">
        <el-steps :active="active"
                  simple>
          <el-step :title="active == 1?'填写购买信息':'已填写'"
                   icon="el-icon-edit"></el-step>
          <el-step title="扫码支付"
                   icon="el-icon-full-screen"></el-step>
        </el-steps>
        <div v-if="active == 1">
          <el-form ref="form"
                   style="margin: 20px ;"
                   :model="form"
                   :rules="rules"
                   label-width="70px">
            <div style="margin-left: 70px;margin-bottom: 4px;"
                 class="font12">
              <el-alert title="温馨提示: 请输入正确手机号，购买成功将立即开通噢!"
                        type="info">
              </el-alert>
            </div>
            <el-form-item label="手机号"
                          required
                          prop="mobile">
              <el-input v-model="form.mobile"
                        maxlength="11"
                        @input="mobileChange"></el-input>
            </el-form-item>
            <div style="margin:0 0 20px 70px;border-radius: 5px;"
                 v-if="mobileFlag">
              <el-alert :title="form.isNew ==1?'用户创建成功':'查询如下用户信息'"
                        type="success"
                        :closable="false"
                        show-icon>
              </el-alert>
              <div class="flexStart"
                   style="padding:10px;margin-top: 4px;background-color: #f5f5f5;">
                <el-image style="width:40px; height:40px;border-radius: 50%;"
                          :src="form.headPortrait"></el-image>
                <span style="margin-left: 20px;">{{ form.username }}</span>
              </div>
            </div>
            <el-form-item label="数量"
                          v-if="data.deliverUnit == 2"
                          required
                          prop="num">
              <el-input-number v-model="form.num"
                               @change="numChange"
                               style="100%"
                               step-strictly
                               :min="1"
                               :max="999999999"></el-input-number>
            </el-form-item>
          </el-form>

          <div class="flexCenter">
            <el-button @click="nextStep">下 一 步</el-button>
          </div>
        </div>
        <div v-show="active==2"
             style="margin: 20px ;">
          <div>
            <div>买家信息</div>
            <div class="flexStart"
                 style="padding:10px;margin-top: 4px;background-color: #f5f5f5;">
              <el-image style="width:40px; height:40px;border-radius: 50%;"
                        :src="form.headPortrait"></el-image>
              <span style="margin:0 10px;">{{ form.username }}</span>
              <el-link type="primary"
                       @click="init(data)">更换</el-link>
            </div>
          </div>
          <div style="margin-top: 10px;">
            <div>产品信息</div>
            <div style="padding:10px;margin-top: 4px;background-color: #f5f5f5;">
              <div>
                <span>名称:</span>
                <span class="font14"
                      style="font-weight: bold;margin-left: 20px;">{{ data.name }}</span>
              </div>
              <div class="flexStart"
                   style="margin-top: 10px;">
                <div>
                  <span>应付:</span>
                  <span style="color: red;font-weight: bold;margin-left: 10px;">¥{{ data.price * form.num }}</span>
                </div>
                <div style="margin-left: 20px;">
                  <span>原价:</span>
                  <s class="font14"
                     style="margin-left: 10px;">¥{{ data.scribingPrice * form.num }}</s>
                </div>
              </div>
            </div>
          </div>
          <div class="flexCenter">
            <div style="flex:1">
              <div class="pay-time">
                <!-- <div class="font14"
                     style="font-weight:600">请使用 <span class="mainColor">微信扫一扫</span> 扫描二维码支付 </div> -->
                <div class="flexCenter"
                     v-if="remainTime!=0"
                     style="margin:10px 0 0 0;font-family: 'bb';">
                  支付倒计时: <span class="mainColor">{{remainTime}}</span>
                </div>
                <div class="pay-qrcode"
                     id="parentNode">
                  <div class="qrcode"
                       ref="qrCodeUrl"></div>
                  <div v-if="remainTime==0"
                       class="mask flexCenter"
                       @click="postbuyTechProduct">
                    <i class="el-icon-refresh-right"></i>
                    已过期 重新获取
                  </div>
                </div>
                <div class="product-pay-item flexCenter">
                  <img src="http://storage.360buyimg.com/payment-assets/sdk/bank/PAY-WEIXIN.png"
                       alt=""
                       style="width:26px;height:26px;;margin-right:4px;"><span style="font-size:16px">微信支付</span>
                </div>
              </div>
            </div>
            <div style="flex:1">
              <img style="width:100%"
                   src="http://storage.360buyimg.com/payment-assets/pc/icon/phone-bg.png"
                   alt="">
            </div>
          </div>
          <div class="flexCenter"
               style="margin-top:10px">
            购买即代表同意钧策咨询 <span class="mainColor"
                  style="cursor: pointer;"
                  @click="getresourceList">《用户隐私条款》</span>
          </div>
        </div>
      </div>
      <div v-show="payStatus">
        <el-alert title="支付成功"
                  type="success"
                  :closable="false"
                  style="width:100%;height: 66px;"
                  show-icon>
        </el-alert>
        <div class="order-card">
          <!-- {{ orderInfo }} -->
          <div style="font-size: 16px;color: #000;font-weight: bold;flex:1;">订单信息</div>
          <div class="product-item">
            <span class="l">订单号</span>
            <span>{{ orderInfo.orderNo }}</span>
          </div>
          <div class="product-item">
            <span class="l">订单时间</span>
            <span>{{ orderInfo.createTime }}</span>
          </div>
          <div class="product-item">
            <span class="l">支付方式</span>
            <span>微信支付</span>
          </div>
        </div>
        <div class="order-card"
             v-if="techRights && techRights.length!=0">
          <div class=" flexStart">
            <div style="font-size: 16px;color: #000;font-weight: bold;flex:1;">产品权益</div>
          </div>
          <div class="product-item"
               v-for="(item,index) in techRights"
               :key="index+'techRights'">
            <div class="name">{{item.name}}</div>
            <span class="l"
                  v-if="item.typeCode!='techStudySchoolMember'&&item.typeCode!='techStudySchoolOperate' && item.typeCode!='techSystemRole' && item.typeCode!='techCoursePackage'">{{item.typeCode == 'techStudySchoolAccount'?'交付账号数量':'兑换码'}}</span>
            <span class="r"
                  v-if="item.typeCode!='techStudySchoolMember'&&item.typeCode!='techStudySchoolOperate'&& item.typeCode!='techSystemRole'&& item.typeCode!='techCoursePackage'">{{item.number}}</span>
            <span class="l"
                  v-if="item.typeCode != 'techStudySchoolAccount' && item.typeCode!='techStudySchoolMember'&&item.typeCode!='techStudySchoolOperate'&& item.typeCode!='techSystemRole'&& item.typeCode!='techCoursePackage'"
                  style="margin-right: 10px;">个,</span>
            <span class="l"
                  v-if="item.typeCode!='techSystemRole'">{{item.typeCode=='techCoursePackage'?'课程有效时长':'每个有效时长'}}</span>
            <span class="r"
                  v-if="item.typeCode!='techSystemRole'">{{item.value?item.value:0}}</span>
            <span class="l"
                  v-if="item.typeCode!='techSystemRole'"
                  style="margin-right: 10px;">天</span>
            <div class="l"
                 v-if="item.typeCode=='techSystemRole'">登录地址 : <span class="r">https://www.jclingshou.com</span>
              <!-- <span style="font-size: 26rpx;cursor: pointer;"
                    class="gui-color-blue"
                    @tap="copy_span">复制</span> -->
            </div>
            <span class="l"
                  v-if="item.typeCode == 'techCoursePackage'">课程数量 <span class="r">{{item.goodsNum}}</span>个 </span>
            <div v-if="item.typeCode!='techCoursePackage'">
              <span v-for="(x,y) in item.spec"
                    :key="y+'spec'">
                <span class="l">{{x.title}}</span>
                <span class="r">{{x.value}}</span>
              </span>
            </div>
          </div>
        </div>
        <div>
          <div class="order-card">
            <div class=" flexStart">
              <div style="font-size: 16px;color: #000;font-weight: bold;flex:1;margin-bottom: 10px;">使用教程</div>
            </div>
            <video style="width: 100%;height:240px;"
                   autoplay
                   controls
                   :poster="orderInfo.specImageUrl"
                   :src="orderInfo.teachVideo"></video>
          </div>
          <div class="order-card">
            <div class="product-item"
                 style="display: flex;align-items: center;justify-content: center;">
              {{orderInfo.wecomQrcodeUrl?'【添加微信】':'关注“零售大讲堂”公众号'}}</div>
            <div class="product-item"
                 style="display: flex;align-items: center;justify-content: center;">
              {{orderInfo.wecomQrcodeUrl?'享受专属客服一对一服务':'及时收取消息通知获取平台福利等噢!'}}</div>
            <div class="product-item"
                 style="display: flex;align-items: center;justify-content: center;">
              <el-image style="width: 150px;height: 150px;"
                        :src="orderInfo.wecomQrcodeUrl?orderInfo.wecomQrcodeUrl:'https://junyiyunpan-1302085701.cos.ap-beijing.myqcloud.com/office_website/assets/home/buttom_djt.png'"></el-image>
            </div>
          </div>
        </div>
      </div>
      <!-- <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="dialogVisible = false">确 定</el-button>
      </span> -->
      <el-dialog width="24%"
                 title="关闭提醒"
                 top="20vh"
                 :visible.sync="innerVisible"
                 :show-close="false"
                 :center="true"
                 append-to-body>
        <div>
          <div class="flexCenter">请确认没有正在支付中的订单，支付完成前请不要关闭该窗口</div>
          <div class="flexCenter"
               style="margin:20px 0">
            <el-button style="margin-right:20px"
                       @click="close">仍然离开</el-button>
            <el-button type="danger"
                       @click="innerVisible = false">我知道了</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 协议 -->
      <el-dialog width="500px"
                 title="用户隐私条款"
                 :visible.sync="innerVisibles"
                 :close-on-click-modal="false"
                 append-to-body>
        <div class="inner_box">
          <div v-html="resourceUrl"></div>
        </div>
        <div class="flexCenter"
             style="margin-top:20px">
          <el-button type="danger"
                     @click="innerVisibles = false">好的</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
import login from '../../../components/login/index.vue'
import { techProductProductType, resourceList, userInfoByMobile, buyTechProduct, payTechProduct, techProductChenk, techProductOrderInfo } from '@/api/api.js'
const validateMobile = (rule, value, callback) => {
  let regPhone = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
  if (value === '') {
    callback(new Error('请填写您的手机号'));
  } else if (!regPhone.test(value)) {
    callback(new Error('请输入正确的手机号格式!'));
  } else {
    callback();
  }
};
export default {
  components: { login },
  data () {
    return {
      innerVisibles: false,
      resourceUrl: null,
      qrcode: null,
      remainTime: 0,
      rules: {
        num: [
          { required: true, message: '请输入数量', trigger: 'blur' },
        ],
        mobile: [
          { validator: validateMobile, trigger: 'blur' }
        ],
      },
      active: 1,
      form: { mobile: null, num: 1 },
      dialogVisible: false,
      data: {},
      mobileFlag: false,
      payData: {},
      orderNo: null,
      timer: null,
      isCode: false,
      payStatus: false,
      orderInfo: {},
      techRights: [],
      innerVisible: false
    }
  },
  switch: {
    dialogVisible (newdata, oldData) {
      if (!newdata) {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null;
        }
      }
    },
    payStatus (newdata, oldData) {
      if (newdata) {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null;
        }
      }
    }
  },
  methods: {
    numChange (e) {
      console.log(e)
    },
    async getresourceList () {  //获取首页资源
      const res = await resourceList({
        showIndex: 26,
        pageNumber: 1,
        pageSize: 100
      })
      // console.log(res)
      if (res.data) {
        this.resourceUrl = res.data[0].resourceUrl
      }
      this.innerVisibles = true;
      console.log(res)
    },
    nextStep () {  //下一步
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postbuyTechProduct();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    mobileChange (e) {  //监听手机号输入
      let regPhone = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
      if (e === '') {
        console.log('')
        this.mobileFlag = false;

      } else if (!regPhone.test(e)) {
        console.log('')
        this.mobileFlag = false;
      } else {
        this.postuserInfoByMobile(e);
      }
    },
    postbuyTechProduct () {  //下单
      let data = {
        specId: this.data.id,
        num: this.form.num,
        userId: this.form.userId,
        orderId: null
      }
      buyTechProduct(data).then(res => {
        console.log(res)
        if (res.code <= 200) {
          this.payData = res.data;
          this.postpayTechProduct();
        }
      })
    },
    postpayTechProduct () {
      let data = {
        specId: this.data.id,
        num: this.form.num,
        userId: this.form.userId,
        orderId: this.payData.id
      }
      payTechProduct(data).then(res => {
        console.log(res)
        if (res.code <= 200) {
          this.creatQrCode(res.qrcodeUrl)
          this.orderNo = res.orderNo;
          // this.gettechProductOrderInfo();
          this.active = 2;
          this.mobileFlag = false;
        }
      })
    },
    toDate (timeStamp, returnType) {
      timeStamp = parseInt(timeStamp);
      var date = new Date();
      if (timeStamp < 90000000000) {
        date.setTime(timeStamp * 1000);
      } else {
        date.setTime(timeStamp);
      }
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      var h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? ('0' + minute) : minute;
      second = second < 10 ? ('0' + second) : second;
      if (returnType == 'str') {
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
      }
      return [y, m, d, h, minute, second];
    },
    postuserInfoByMobile (e) {  //查询用户信息
      let aseSign = this.$md5(e + this.toDate(new Date().getTime(), 'str'))
      let sendTime = this.toDate(new Date().getTime(), 'str')
      let data = {
        mobile: e,
        aseSign,
        sendTime
      }
      userInfoByMobile(data).then(res => {
        console.log(res)
        if (res.code <= 200) {
          let data = res.data;
          this.form = { ...this.form, ...data };
          this.mobileFlag = true;
        }
      })
    },
    init (data) {  //初始化
      this.data = data;
      this.form = { mobile: null, num: 1 };
      this.active = 1;
      this.remainTime = 0;
      setTimeout(() => {
        this.$refs.form.resetFields();
      }, 500);
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null;
      }
      console.log(this.qrcode)
      if (this.qrcode) {
        // 如果二维码对象已存在，则更新链接
        this.qrcode.clear(); // 清除之前的二维码
        // this.qrcode.makeCode(url); // 生成新的二维码  innerHTML = ""
        this.$refs.qrCodeUrl.innerHTML = "";
        console.log(this.$refs.qrCodeUrl)
      }
      console.log(this.qrcode)
      this.mobileFlag = false;
      this.dialogVisible = true;



      // this.orderNo = '20231031160810000001';
      // this.gettechProductOrderInfo();
      // this.payStatus = true;
    },
    handleClose (e) {  //关闭弹窗
      console.log(e);
      if (this.active == 2 && !this.payStatus) {
        this.innerVisible = true;
      } else {
        this.close();
      }

      // this.dialogVisible = false;
      // clearInterval(this.timer)
      // this.timer = null;
    },
    close () {
      this.dialogVisible = false;
      this.innerVisible = false;
      this.active = 1;
      this.form.mobile = null;
      this.payStatus = false;
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null;
      }
    },
    // 创建支付二维码  || "https://idivui.com/components/spin"
    creatQrCode (span) {
      // this.getresourceList()
      let that = this;
      that.mobileFlag = false;
      that.active = 2;
      if (that.qrcode) {
        // 如果二维码对象已存在，则更新链接
        that.qrcode.clear(); // 清除之前的二维码
        // this.qrcode.makeCode(url); // 生成新的二维码  innerHTML = ""
        that.$refs.qrCodeUrl.innerHTML = "";
        console.log(that.$refs.qrCodeUrl)
      }
      setTimeout(() => {
        that.$nextTick(() => {
          const h = document.getElementById("parentNode").offsetHeight
          console.log(QRCode)
          console.log(that.$refs.qrCodeUrl)
          console.log(span)
          that.qrcode = new QRCode(that.$refs.qrCodeUrl, {
            text: span,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          });
          console.log(this.qrcode)
          // that.isCode = true;
          that.queryState();
        })
      }, 600);
    },
    // 轮询付款结果
    queryState () {
      this.timer = setInterval(() => {
        techProductChenk(this.orderNo).then(res => {
          console.log(res)
          if (res.code == 200) {
            // 订单完成
            if (res.data.payState == 2) {
              if (this.timer) {
                clearInterval(this.timer)
                this.timer = null;
                this.$emit('wechatPaySuccess');
                this.gettechProductOrderInfo();
              }
            }
            if (res.data && res.data.remainTime > 0) {
              this.remainTime = this.formatSeconds(res.data.remainTime)
            } else {
              this.remainTime = 0;
              if (this.timer) {
                clearInterval(this.timer)
                this.timer = null;
                this.$emit('orderStatusClose');
              }
            }
            // 订单关闭
            if (res.data.payState == 0) {
              if (this.timer) {
                clearInterval(this.timer)
                this.timer = null;
                this.$emit('orderStatusClose');
              }
            }
          }
        })
        // this.$http({
        //   url: this.$http.vaUrl('/native/payQuery/state'),
        //   method: 'post',
        //   params: this.$http.adornParams({
        //     'tradeNo': this.tradeNo,
        //   })
        // }).then(({ data: res }) => {
        //   if (res.code === 0) {
        //     this.payData = res
        //     if (this.timer) {
        //       clearInterval(this.timer)
        //       this.timer = null
        //       this.curIndex = -999
        //     }
        //   }
        // })
      }, 1000);
    },
    gettechProductOrderInfo () {  //查询订单信息
      // this.gettechProductProductType();
      techProductOrderInfo(this.orderNo).then(res => {
        console.log(res)
        if (res.code <= 200) {
          let arr = res.data;
          const {
            techRights
          } = res.data;
          console.log(techRights)
          this.getproductType().then(success => {
            console.log(success)
            if (success.code == 200 && success.data) {
              const data = success.data;
              for (let i = 0; i < techRights.length; i++) {
                const iItem = techRights[i];
                console.log(iItem)
                for (var x = 0; x < data.length; x++) {
                  const xItem = data[x];
                  if (iItem.typeCode == xItem.typeCode && iItem.attach && xItem
                    .attach) {
                    iItem['spec'] = [];
                    let iItemAttach = JSON.parse(iItem.attach);
                    let xItemAttach = xItem.attach
                    for (let x in iItemAttach) {
                      for (let y in xItemAttach) {
                        if (x == xItemAttach[y]) {
                          if (x == 'courseIds') {
                            iItem['goodsNum'] = iItemAttach[xItemAttach[y]]
                              .split(',').length
                          }
                          let arr = {
                            title: y,
                            value: iItemAttach[xItemAttach[y]]
                          }
                          iItem.spec.push(arr);
                        }
                      }
                    }
                  }
                }
              }
            }
          })
          setTimeout(() => {
            this.techRights = techRights;
            console.log(this.techRights)
          }, 220);
          if (this.timer) {
            clearInterval(this.timer)
            this.timer = null;
          }
          this.payStatus = true;
          this.orderInfo = arr;
        }
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null;
        }
      })
    },
    async getproductType () {
      return await techProductProductType()
    },
    //  秒数转化为时分秒
    formatSeconds (value) {
      //  秒
      let second = parseInt(value)
      //  分
      let minute = 0
      //  小时
      let hour = 0
      //  天
      //  let day = 0
      //  如果秒数大于60，将秒数转换成整数
      if (second > 60) {
        //  获取分钟，除以60取整数，得到整数分钟
        minute = parseInt(second / 60)
        //  获取秒数，秒数取佘，得到整数秒数
        second = parseInt(second % 60)
        //  如果分钟大于60，将分钟转换成小时
        if (minute > 60) {
          //  获取小时，获取分钟除以60，得到整数小时
          hour = parseInt(minute / 60)
          //  获取小时后取佘的分，获取分钟除以60取佘的分
          minute = parseInt(minute % 60)
          //  如果小时大于24，将小时转换成天
          //  if (hour > 23) {
          //    //  获取天数，获取小时除以24，得到整天数
          //    day = parseInt(hour / 24)
          //    //  获取天数后取余的小时，获取小时除以24取余的小时
          //    hour = parseInt(hour % 24)
          //  }
        }
      }

      let result = '' + parseInt(second) + '秒'
      if (minute > 0) {
        result = '' + parseInt(minute) + '分' + result
      }
      if (hour > 0) {
        result = '' + parseInt(hour) + '小时' + result
      }
      //  if (day > 0) {
      //    result = '' + parseInt(day) + '天' + result
      //  }
      // console.log('result：', result)
      return result
    },
  }

}
</script>
<style lang="less" scoped>
.pay-time {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  // cursor: pointer;
  .pay-qrcode {
    margin: 20px 0;
    padding: 4px;
    border: 2px solid #eee;
    position: relative;
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.9);
      color: #fff;
      cursor: pointer;
    }
    .qrcode {
      width: 200px;
      height: 200px;
      margin: 0 auto;
    }
  }
}
.order-card {
  padding: 10px 20px;
  margin-top: 4px;
  background-color: #f5f5f5;
  border-radius: 5px;
  margin-top: 10px;
  .product-item {
    padding: 5px 0;
    vertical-align: middle;

    .name {
      margin-bottom: 5px;
      font-size: 15px;
      color: #000;
      font-weight: bold;
    }

    .l {
      font-size: 14px;
      margin-right: 5px;
    }

    .r {
      font-size: 12px;
      margin: 0 5px;
      color: #ff4343;
    }

    .product-title {
      font-size: 12px;
      font-weight: 700;
      color: #444444;
    }

    .product-desc {
      font-size: 12px;
      font-weight: 300;
      color: #444444;
    }
  }
}
</style>